import Proxy from '../Proxy';

class NotificationProxy extends Proxy {
  /**
   * The constructor for the EstimationComplexProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('notifications', parameters);
  }

  sendAnnouncement(data = {}) {
    return this.submit('post', `${this.endpoint}/announcement`, data);
  }

  listBoard(data = {}) {
    return this.submit('get', `${this.endpoint}/board`, data);
  }
}

export default NotificationProxy;
